import { render, staticRenderFns } from "./InfoPopup.vue?vue&type=template&id=fe54d1f6&scoped=true"
import script from "./InfoPopup.vue?vue&type=script&lang=js"
export * from "./InfoPopup.vue?vue&type=script&lang=js"
import style0 from "./InfoPopup.vue?vue&type=style&index=0&id=fe54d1f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe54d1f6",
  null
  
)

export default component.exports